<template>
  <div v-if="visible" class="modal-backdrop-q">
    <div class="modal-card-q">
      <h5 class="modal-title-q">Conectar el bot al canal</h5>

      <p class="modal-text-q">
        Para poder vender este servicio, el bot debe estar dentro del canal de Telegram
        que has indicado en el campo <strong>Enlace</strong>.
      </p>

      <ol class="modal-list-q">
        <li>Abre Telegram y entra en tu canal.</li>
        <li>
          Añade al bot <b>{{ botName }}</b> como <strong>administrador</strong> del canal
          (con permiso para invitar usuarios y ver miembros).
        </li>
        <li>
          Envía en el canal el siguiente comando de activación
          (puedes copiarlo con el botón):
        </li>
      </ol>

      <!-- 🔥 Bloque comando /initCanal -->
      <div class="init-box-q" v-if="codigoInit">
        <label class="init-label-q">Comando de activación:</label>
        <div class="init-row-q">
          <code class="init-code-q">/initCanal {{ codigoInit }}</code>

          <button type="button" class="btn-copy-q" @click="copiarComando">
            Copiar
          </button>
        </div>
        <p class="init-help-q">
          Pégalo en el canal de Telegram y ejecútalo. Una vez hecho,
          vuelve aquí y pulsa <strong>"Ya he agregado el bot"</strong>.
        </p>
      </div>

      <div class="init-box-q init-box-empty-q" v-else>
        <p class="init-help-q">
          No se ha podido generar automáticamente el código de activación.
          Revisa que el canal exista en Quanty o contacta con soporte.
        </p>
      </div>

      <p class="modal-text-small-q">
        <strong>Enlace indicado:</strong><br />
        <span class="enlace-q">{{ enlace }}</span>
      </p>

      <div class="modal-actions-q">
        <button type="button" class="btn-secondary-q" @click="$emit('cerrar')">
          Cerrar
        </button>
        <button type="button" class="btn-primary-q" @click="$emit('reintentar')">
          Ya he agregado el bot
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalInstruccionesBot",
  props: {
    visible: { type: Boolean, default: false },
    enlace: { type: String, default: "" },
    codigoInit: { type: String, default: "" }, // 👈 UUID del canal
    botName: {
      type: String,
      default: "", 
    },
  },
  methods: {
    async copiarComando() {
      if (!this.codigoInit) return;
      const comando = `/initCanal ${this.codigoInit}`;

      try {
        await navigator.clipboard.writeText(comando);
        // Si quieres algo más pro, luego lo cambiamos por un showSwal desde el padre
        // de momento dejamos feedback básico:
        // alert("Comando copiado al portapapeles");
      } catch (e) {
        console.error("No se pudo copiar el comando", e);
      }
    },
  },
};
</script>

<style scoped>
.modal-backdrop-q {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-card-q {
  background: var(--q-card);
  border-radius: 14px;
  max-width: 520px;
  width: 95%;
  padding: 1.8rem 1.6rem;
  box-shadow: 0 18px 45px rgba(0, 0, 0, 0.5);
  border: 1px solid var(--q-border-md);
}

.modal-title-q {
  font-size: 1.3rem;
  font-weight: 700;
  margin-bottom: 0.6rem;
  color: var(--q-text);
}

.modal-text-q {
  font-size: 0.95rem;
  color: var(--q-muted);
  margin-bottom: 0.8rem;
}

.modal-list-q {
  margin-left: 1.2rem;
  margin-bottom: 1rem;
  font-size: 0.9rem;
  color: var(--q-muted);
}

.modal-list-q li + li {
  margin-top: 0.35rem;
}

.init-box-q {
  background: var(--q-hover);
  border-radius: 10px;
  padding: 0.75rem 0.9rem;
  margin-bottom: 0.8rem;
  border-left: 4px solid var(--q-gold);
}

.init-box-empty-q {
  border-left-color: var(--q-amber);
}

.init-label-q {
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--q-text);
  display: block;
  margin-bottom: 0.4rem;
}

.init-row-q {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin-bottom: 0.35rem;
}

.init-code-q {
  background: var(--q-card-alt);
  color: var(--q-text);
  padding: 0.35rem 0.6rem;
  border-radius: 6px;
  font-size: 0.85rem;
  font-family: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Monaco,
    Consolas, "Liberation Mono", "Courier New", monospace;
  flex: 1;
  white-space: nowrap;
  overflow-x: auto;
}

.btn-copy-q {
  border: none;
  background: var(--q-gold);
  color: var(--q-gold-on);
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.4rem 0.7rem;
  cursor: pointer;
  flex-shrink: 0;
}

.btn-copy-q:hover {
  background: var(--q-gold-hover);
}

.init-help-q {
  font-size: 0.8rem;
  color: var(--q-muted);
}

.modal-text-small-q {
  font-size: 0.8rem;
  color: var(--q-muted);
  margin-top: 0.6rem;
}

.enlace-q {
  word-break: break-all;
}

.modal-actions-q {
  display: flex;
  justify-content: flex-end;
  gap: 0.8rem;
  margin-top: 1.2rem;
}

.btn-primary-q,
.btn-secondary-q {
  min-width: 150px;
  height: 40px;
  padding: 0 18px;
  border-radius: 999px;
  font-size: 0.9rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
}

.btn-primary-q {
  background: var(--q-gold);
  color: var(--q-gold-on);
}

.btn-primary-q:hover {
  background: var(--q-gold-hover);
}

.btn-secondary-q {
  background: var(--q-hover);
  color: var(--q-text);
  border: 1px solid var(--q-border-md);
}

.btn-secondary-q:hover {
  background: var(--q-border-md);
}

@media (max-width: 480px) {
  .modal-card-q {
    padding: 1.4rem 1.1rem;
  }

  .modal-actions-q {
    flex-direction: column-reverse;
  }

  .btn-primary-q,
  .btn-secondary-q {
    width: 100%;
  }

  .init-row-q {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-copy-q {
    width: 100%;
    text-align: center;
  }
}
</style>
